import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_CI_67 } from "@/lib/programs/ciudadesImperiales67";

export default function CiudadesImperiales67Page() {
  return <ProgramTemplate program={PROGRAM_CI_67} variant="ci" showJourneyChronology />;
}
